var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useContext, useState, useMemo, useRef } from 'react';
import { Context, ThemeType } from "~/Components/Theme/ThemeProvider";
import { useTheme } from '@mui/material/styles';
import ReadMeData from "~/Data/ReadMe.json";
import List from '@mui/material/List/List';
import ListItem from '@mui/material/ListItem/ListItem';
import ListItemButton from '@mui/material/ListItemButton/ListItemButton';
import ListItemText from '@mui/material/ListItemText/ListItemText';
import Divider from '@mui/material/Divider/Divider';
import { Resizable } from 're-resizable';
import Paper from '@mui/material/Paper/Paper';
import Box from '@mui/material/Box/Box';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse/Collapse';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import DarkLightToggle from './DarkLightToggle';
import Button from '@mui/material/Button';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import RotateStyle from "~/Components/RotateClass/index.css";
import classNames from 'classnames';
import { PrefixUri } from '~/Utils/Util';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import ListItemIcon from '@mui/material/ListItemIcon/ListItemIcon';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import useMediaQuery from '@mui/material/useMediaQuery';
var RenderTitleAndContent = function (_a) {
    var _b = _a.titleAndContent, Title = _b.Title, TitleId = _b.TitleId, Content = _b.Content, SubContents = _b.SubContents, _c = _a.prefix, prefix = _c === void 0 ? null : _c, _d = _a.pl, pl = _d === void 0 ? 0 : _d;
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var uri = PrefixUri(prefix, TitleId);
    // console.log(`prefix=${prefix}, TitleId=${TitleId}, pathname=${pathname}, uri=${uri}`);
    var curActive = useMemo(function () {
        if (TitleId === '') {
            return pathname === '/';
        }
        var preUri = '/' + uri;
        if (!pathname.startsWith(preUri)) {
            return false;
        }
        var prePath = pathname;
        if (!prePath.endsWith('/')) {
            prePath += '/';
        }
        if (!preUri.endsWith('/')) {
            preUri += '/';
        }
        console.log(prePath, preUri);
        return prePath.startsWith(preUri);
        // if(pathname.startsWith(`/${uri}`)) {
        //     console.log(`pathname=${pathname}, uri=${uri}, ${pathname.replace(`/${uri}`, '')}`);
        //     console.log(pathname.replace(`/${uri}`, '').replace('/', ''))
        // }
        // return pathname.startsWith(`/${uri}`) && (pathname.replace(`/${uri}`, '').replace('/', '') === '');
    }, [TitleId, pathname]);
    var _e = useState(curActive), open = _e[0], setOpen = _e[1];
    var handleClick = function () {
        setOpen(function (orl) { return !orl; });
        if (Content !== "") {
            navigate(uri);
        }
    };
    return (_jsxs(List, { dense: true, disablePadding: true, children: [_jsxs(ListItemButton, { onClick: handleClick, sx: { pl: pl }, selected: curActive, children: [_jsxs(ListItem, { children: [TitleId === "" && _jsx(ListItemIcon, { children: _jsx(HomeTwoToneIcon, {}) }), _jsx(ListItemText, { primary: TitleId === ""
                                    ? "SaintsField"
                                    : _jsx(Markdown, { remarkPlugins: [remarkGfm], disallowedElements: ['p'], unwrapDisallowed: true, children: Title }) })] }), SubContents.length > 0 && (open ? _jsx(ExpandLess, {}) : _jsx(ExpandMore, {}))] }), TitleId === "" && _jsxs(_Fragment, { children: [_jsxs(ListItemButton, { component: Link, to: "/search", sx: { pl: 4 }, selected: pathname === "/search", children: [_jsx(ListItemIcon, { children: _jsx(SearchTwoToneIcon, {}) }), _jsx(ListItemText, { primary: "Search" })] }), _jsx(Divider, {}), _jsx(Box, { sx: { height: 5 } })] }), SubContents.length > 0 && _jsx(Collapse, { in: open, children: SubContents.map(function (eachContent) { return _jsx(RenderTitleAndContent, { titleAndContent: eachContent, prefix: PrefixUri(prefix, TitleId), pl: pl + 4 }, PrefixUri(prefix, TitleId, eachContent.TitleId)); }) })] }, TitleId));
};
var EnableOkType = {
    right: true,
    topRight: true,
    bottomRight: true,
};
var EnableNotType = {
    right: false,
    topRight: false,
    bottomRight: false,
};
var EnableOtherType = {
    top: false,
    bottom: false,
    left: false,
    bottomLeft: false,
    topLeft: false,
};
var DefaultWidth = 180;
var MinWidth = 50;
export default (function () {
    // console.log(rotate180);
    var _a;
    var _b = useContext(Context), theme = _b.theme, setTheme = _b.setTheme;
    var curTheme = useTheme();
    var matches = useMediaQuery(curTheme.breakpoints.down('sm'));
    var initIsMobile = useMemo(function () {
        return matches;
    }, []);
    var readMe = ReadMeData;
    var resizableRef = useRef(null);
    var _c = useState(DefaultWidth), resizableSize = _c[0], setResizableSize = _c[1];
    var _d = useState(!initIsMobile), enableResize = _d[0], setEnableResize = _d[1];
    var ResizeCallback = function (event, direction, elementRef, delta) {
        // console.log(delta.width);
        if (enableResize) {
            setResizableSize(delta.width);
        }
    };
    var onResizeControlClick = function () {
        var _a, _b;
        setEnableResize(function (enabled) { return !enabled; });
        if (enableResize) {
            (_a = resizableRef.current) === null || _a === void 0 ? void 0 : _a.updateSize({ width: MinWidth });
        }
        else {
            (_b = resizableRef.current) === null || _b === void 0 ? void 0 : _b.updateSize({ width: Math.max(resizableSize, DefaultWidth) });
        }
    };
    // const onHidePanel = () => {
    //     setEnableResize(false);
    //     resizableRef.current?.updateSize({width: MinWidth});
    // }
    return _jsxs(_Fragment, { children: [_jsx(Box, { sx: { position: 'fixed', top: 0, right: 0 }, children: _jsx(DarkLightToggle, { isDark: theme === ThemeType.Dark, onChange: function (toDark) { return setTheme(toDark ? ThemeType.Dark : ThemeType.Light); } }) }), _jsxs(Box, { sx: { display: 'flex' }, children: [_jsx(Resizable, { enable: __assign(__assign({}, EnableOtherType), (enableResize ? EnableOkType : EnableNotType)), defaultSize: { width: initIsMobile ? MinWidth : DefaultWidth }, ref: function (ref) { resizableRef.current = ref; }, onResize: ResizeCallback, 
                        // style={{position: 'sticky', top: 0}}
                        style: { minWidth: 0, maxHeight: 'calc(100vh - 10px)' }, children: _jsxs(Paper, { elevation: 3, sx: { overflowX: 'hidden', maxHeight: 'calc(100vh - 10px)', position: 'sticky', top: 0 }, children: [_jsx(Button, { fullWidth: true, onClick: onResizeControlClick, endIcon: _jsx(MenuOpenIcon, { classes: { root: classNames(RotateStyle.rotateBase, (_a = {},
                                                _a[RotateStyle.rotate180] = !enableResize,
                                                _a)) } }), children: enableResize && "Hide" }), _jsxs(Collapse, { in: enableResize, children: [_jsx(Divider, {}), readMe.map(function (eachReadMe) { return _jsx(RenderTitleAndContent, { titleAndContent: eachReadMe, prefix: null }, eachReadMe.TitleId); })] })] }) }), _jsx(Box, { sx: { width: 1, minWidth: 0 }, children: _jsx(Outlet, {}) })] })] });
});
